import React, { useCallback, useEffect, useState, ChangeEvent } from 'react'
import makeStyles from '@mui/styles/makeStyles';

import {
  ILayout_Editor,
  ILayout_Cell_Props_Table,
  ILayout_Table,
} from '@kaidam/fc-shared/src/types/layout'

import TinyButton from '../../widgets/TinyButton'
import Window from '../../dialog/Window'
import icons from '../../../icons'
import TableEditorWidget from '../../widgets/TableEditor'

const EditIcon = icons.imageSearch

/*

  EDITOR

*/
const useStyles = makeStyles(theme => ({
  editorContainer: {
    height: '100%',
  },
  sectionContainer: {
    height: '100%',
    padding: theme.spacing(4),
  },
  image: {
    width: '150px',
    maxWidth: '150px',
    border: '1px solid #000',
  },
  settingsRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    '& .shrink': {
      flexGrow: 0,
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
    },
    '& .grow': {
      flexGrow: 1,
      '& input': {
        textAlign: 'right',
      }
    },
    '& .caption': {
      flexGrow: 1,
      marginTop: theme.spacing(1),
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
    },
  },
  linkTitle: {
    color: theme.palette.grey[500],
  },
  gridContainer: {
    backgroundColor: '#fff',
  }
}))

const TableEditor: ILayout_Editor<ILayout_Cell_Props_Table> = ({
  cell,
  triggerEdit,
  onChange,
}) => {

  const classes = useStyles()

  const [ editing, setEditing ] = useState(false)
  const [ editingData, setEditingData ] = useState<ILayout_Table>(null)

  const {
    table,
  } = cell.data

  const onEdit = useCallback(async () => {
    setEditingData(table)
    setEditing(true)
  }, [
    table,
  ])

  const onSubmit = useCallback(async () => {
    let update: Partial<ILayout_Cell_Props_Table> = {
      table: editingData,
    }
    onChange(update)
    setEditing(false)
    setEditingData(null)
  }, [
    editingData,
  ])

  useEffect(() => {
    if(triggerEdit) onEdit()
  }, [
    triggerEdit,
  ])

  return (
    <div>
      <TinyButton
        size="small"
        color="primary"
        onClick={ onEdit }
      >
        Edit Table
      </TinyButton>
      {
        editing && (
          <Window
            open
            size="lg"
            compact
            submitTitle="Update"
            noScroll
            fullHeight
            onSubmit={ onSubmit }
            withCancel
            onCancel={ () => {
              setEditing(false)
            }}
          >
            <div className={ classes.gridContainer }>
              <TableEditorWidget
                data={ editingData }
                onChange={(newTable) => {
                  setEditingData(newTable)
                }}
              />
            </div>
          </Window>
        )
      }
    </div>
  )
}

export default TableEditor